import styled from 'styled-components';

interface IContainerProps {
  hasImage: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .box-AddList {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    .containerDropZone {
      display: flex;
      align-items: end;
      p {
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.colors.tertiary_500};
      }
      .contentDropZone {
        display: flex;
        align-items: ${({ hasImage }) => (hasImage ? 'center' : '')};
        justify-content: ${({ hasImage }) => (hasImage ? 'center' : '')};
        background: ${({ theme }) => theme.colors.gray_250};
        border-radius: 100%;
        width: 3.5rem;
        max-width: 3.5rem;
        height: 3.5rem;
        max-height: 3.5rem;
        .iconAdd {
          width: 2.5rem;
          height: 2.5rem;
        }
      }
    }
  }
  .MuiInput-input {
    font-size: 1.2rem;
  }
  .buttonModal {
    display: flex;
    justify-content: flex-end;
  }
`;
